var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentBlueIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 72,
    viewBox: "0 0 103 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_19904_12246)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 4,
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 5,
    width: 62,
    height: 62,
    rx: 31,
    stroke: "#5078A6",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2 45H24.8C24.5613 45 24.3324 44.9052 24.1636 44.7364C23.9948 44.5676 23.9 44.3387 23.9 44.1V27.9C23.9 27.6613 23.9948 27.4324 24.1636 27.2636C24.3324 27.0948 24.5613 27 24.8 27H39.2C39.4387 27 39.6676 27.0948 39.8364 27.2636C40.0052 27.4324 40.1 27.6613 40.1 27.9V44.1C40.1 44.3387 40.0052 44.5676 39.8364 44.7364C39.6676 44.9052 39.4387 45 39.2 45ZM38.3 43.2V28.8H25.7V43.2H38.3ZM28.4 31.5H35.6V33.3H28.4V31.5ZM28.4 35.1H35.6V36.9H28.4V35.1ZM28.4 38.7H32.9V40.5H28.4V38.7Z",
    fill: "#5078A6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_19904_12246",
    x: -38.4,
    y: -32.8,
    width: 140.8,
    height: 140.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_19904_12246"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_19904_12246",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentBlueIcon);
export default __webpack_public_path__ + "static/media/document-blue-icon.b6f7716b51fb9a0260fb8bacd43fc47e.svg";
export { ForwardRef as ReactComponent };